import JwtDecode from 'jwt-decode';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { router } from '@/routes';
import { Auth } from '@/models/auth';
import { User } from '@/models/user';
import { UserAPI } from '@/api/user.api';
import { BASE_PATH_APP } from '@/commons/config';

import GlobalStore from '@/store/modules/global';

import { Sector } from '@/models/sector';

const AUTH = `${BASE_PATH_APP}-auth`;
const userApi = new UserAPI();

export interface UserDecode {
  sub: number
  proprietario: string
  placa: string
  renavam: string
  modelo: string
  cor: string
  municipio: Array<string>
  roles: Array<string>
  // sector: Sector
}

const currentUser = () => {
  const { token = null, functionalities = [] } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const {
    sub,proprietario,placa,renavam,modelo,cor,municipio,roles
  } = JwtDecode<UserDecode>(token);
  return new User(sub,proprietario,placa,renavam,modelo,cor,municipio,functionalities,roles);
};

const userSubject = new BehaviorSubject(currentUser());

userSubject.subscribe((user: User) => {
  if (GlobalStore) {
    GlobalStore.setUser(user);
  }
});

const login = (
  placa: string,
  renavam: string,
  returnUrl?: string,
): Observable<User> => userApi
  .signin(placa, renavam)
  .pipe(map((response) => setSession(response, returnUrl)));

const logout = (): void => {
  localStorage.removeItem(AUTH);
  userSubject.next(null);
  router.push('/login');
};

const setSession = (authResult: any, returnUrl: any): User => {
  buildAuth(authResult);

  userSubject.next(currentUser());
  router.push(returnUrl || '/');

  return userSubject.value;
};

const buildAuth = ({ token, functionalities }: Auth) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }));
};

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};
  return token;
};

export default {
  login,
  logout,
  get currentUserValue() {
    return userSubject.value;
  },
  get token() {
    return currentToken();
  },
};
